<p-menu #menu [model]="items" [popup]="true" [styleClass]="'text-sm'"></p-menu>

@if (feedback) {
  <!-- visualizar -->
  <app-modal [header]="'Visualizar Mensagem'" [style]="'w-full max-w-lg'"
    [isShow]="showMessageModal" (cancel)="showMessageModal = false;">
    <div><p>{{feedback.message}}</p></div>
  </app-modal>
}
